import { render } from "./UpdateAcademyPage.vue?vue&type=template&id=ff862c9a"
import script from "./UpdateAcademyPage.vue?vue&type=script&lang=js"
export * from "./UpdateAcademyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__